import React from "react";
import BlogTemplate from "./BlogTemplate";

// Import your images here (update paths as needed)
import InputFileImage from "../../assets/images/Blogs/SecurityModelTesting/input_file.png";
import CmdImage from "../../assets/images/Blogs/SecurityModelTesting/cmd_prompt.png";
import ResultDirImage from "../../assets/images/Blogs/SecurityModelTesting/result_dir.png";
import ReportImage from "../../assets/images/Blogs/SecurityModelTesting/report.png";
import AdminDataImage from "../../assets/images/Blogs/SecurityModelTesting/admin_data.png";

const SecurityModelTesting = () => {
  return (
    <BlogTemplate
      seoTitle="Siemens Teamcenter 11.2.x Supports Automation of Security Model Testing | NexTech PLM"
      seoDescription="Learn how Siemens Teamcenter 11.2.x supports the automation of security model testing using the AM rule test harness tool to prevent rights escalation."
      seoKeywords="Teamcenter 11.2.x, Security Model Testing, AM Rule Test Harness, Access Manager, Siemens PLM"
      ogImage="https://nextechplm.com/og/security-model-testing.png"
      pageUrl="https://nextechplm.com/blog/security-model-testing"
      bannerTitle="Teamcenter 11.2.x Security Model Testing"
    >
      
      {/* Introduction Section */}
      <section className="container content-container">
        <div className="text-container">
          <p>
            The world has become a scare place, everyday we hear about different security problems putting more and more challenges in ensuring the protection of senstive information data in PLM enviroment. In this age of costant connectivity and rapid communication, security is paramount where security threat can also orignates from people working inside the company by exploiting rights (AM privileges) escalation and can create serious loss or damage to the company.
          </p>
          <p>
            This poses dire need to ensure that your security model is intact with your business security requirements and ensure user is not getting extra access than he required and also he is not restricted to access which he required to perform his job. To address this, Siemens Teamcenter PLM now supports the capability to thoroughly test your security model automatically using the AM rule test harness tool.
          </p>
          <p>
            This tool is particularly useful because you only need to create a test input file once, and then you can re-run it whenever you want to ensure everything aligns with your business security requirements. For example, during a Teamcenter upgrade, this tool tremendously saves time in user access testing and helps avoid human errors. Input files written during an upgrade can be reused for subsequent patching, upgrades, or new development work, allowing teams to avoid repetitive regression testing and build confidence in their security models.
          </p>
        </div>
      </section>

      {/* Scenarios Section */}
      <section className="blog-section" style={{ backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
        <h2 className="sub-title">Key Implementation Scenarios</h2>

        <h3 className="key-element-title">Scenario 1: Develop Security Model for your Production Enviorment Using Development Environment</h3>
        <ul className="blog-list">
          <li>Develop security model in development enviroment as per your busienss security requirements by adding new AM rule and/or editing AM rules.</li>
          <li>Create test input file for checking different privilges for users/group/role/project combination for set of data.</li>
          <li>Run the test on development enviroment and ensure everything is passed as per your expecation through AM rule test report.</li>
          <li>Export the rule tree and load in production and run the test using same input file created in step 2 and ensure that security is intact with your expectation.</li>
          <li>Run the test on production enviroment and ensure everything is passed as per your expecation through AM rule test report.</li>
          <li>Repeat steps 1 to 5 until you fully develop security model for your busienss.</li>
        </ul>

        <h3 className="key-element-title" style={{ marginTop: "2rem" }}>Scenario 2: Ensure Security Model is Intact after Patch, Customziation, Major Upgrade, or Changes in AM rule tree</h3>
        <ul className="blog-list">
          <li>Create test input file for checking different privilges for users/group/role/project combination for set of data.</li>
          <li>Run the test on production enviroment and ensure everything is passed as per your expecation through AM rule test report.</li>
          <li>Perform the Patching, Customziation, Upgrade, Changes in AM rule tree for new busienss requirements.</li>
          <li>Re-run the test to ensure your security is intact and not disturbed because of above actions.</li>
        </ul>
      </section>

      {/* How to Use Section */}
      <section className="blog-section">
        <h2 className="sub-title">How to use?</h2>
        
        <h3 className="key-element-title">1. Create Test Input File</h3>
        <p>Create a test input file using the sample XML format.</p>
        <div className="image-container" style={{ margin: "2rem auto", width: "100%" }}>
           <img src={InputFileImage} alt="Sample XML input file for AM rule test harness" />
        </div>

        <h3 className="key-element-title">2. Run the Utility</h3>
        <p>Run the utlity named as <code>am_rule_test_harness</code> available in the <code>TC_ROOT/bin</code> directory on the TC Commnad promt.</p>
        <div className="image-container" style={{ margin: "2rem auto", width: "100%" }}>
           <img src={CmdImage} alt="Command prompt execution of am_rule_test_harness" />
        </div>

        <h3 className="key-element-title">3. Analyze Test Results</h3>
        <p>Analyze the test result created at the SecurityModelTesting directory.</p>
        <div className="image-container" style={{ margin: "2rem auto", width: "100%", maxWidth: "600px" }}>
           <img src={ResultDirImage} alt="Test results generated in SecurityModelTesting directory" />
        </div>

        <p>
          Open the directory AdminDataReport and click on <code>index.html</code> for html test report which looks like as below where you can easily identify what are all test have passed and what are failed. Also, you can easily identify the branch of ACL including ACE, Accessor, and Conditions which caused failure to easily fix the AM rule tree.
        </p>
        <div className="image-container" style={{ margin: "2rem auto", width: "100%" }}>
           <img src={ReportImage} alt="HTML test report showing passed and failed privilege tests" />
        </div>

        <p className="text-bold">
          Identify which ACL rule entry or accessor is failing the test by clicking on the failure node in the report which will show exact the entry. Fix the AM rule tree accordingly and Rerun the same test to ensure that security is as per your expectation.
        </p>
      </section>

      {/* Benefits Section */}
      <section className="blog-section" style={{ backgroundColor: "#f0f8ff", borderRadius: "8px" }}>
        <h2 className="sub-title">Benefits</h2>
        <ul className="blog-list">
          <li><strong>Great efforts saving</strong> as you can automate complete security testing just by writing once your test cases in xml format and then after it’s a matter of running the test.</li>
          <li>Avoid human errors in testing.</li>
          <li>Help to develop security model using development environment very effectively.</li>
          <li>Also help to take snapshot of other admin data to capture the site state when you perform the security test. In case you don’t want this data to be exported you can this tool only using AM rule tree switch which ensures only AM rule tree snap will be taken and not the other data.</li>
        </ul>
        <div className="image-container" style={{ margin: "2rem auto", width: "100%", maxWidth: "400px" }}>
           <img src={AdminDataImage} alt="Admin data exported by tool on am rule test execution" />
        </div>
      </section>

    </BlogTemplate>
  );
};

export default SecurityModelTesting;